import { Injectable } from "@angular/core";
import { Integration, IntegrationDynamicFieldType, IntegrationFeature } from "@core/models/integration.model";

@Injectable({
    providedIn: 'root'
  })
  export class IntegrationAdapter{
    

    adapt(x:any):Integration{
      return { 
        id: x.id, 
        name: x.name, 
        logo: x.logo, 
        description: x.description, 
        url:x.manualUrl??'', 
        btn:x.manualText??'more-info', 
        type:x.type, 
        locked:false,
        isActive:x.isActive??false,
        deprecated: x.deprecated ?? false,
        requiredFeature: x.requiredFeature ?? null,
        dynamicFields: (x.integrationDynamicFields??[]).map((df:any) => ({
            id:   df.id,
            type: df.type as IntegrationDynamicFieldType,
            value: df.value??''
        })),
        features: (x.integrationFeatures??[]).map( (f:any) => { 
          return { id:f.id, feature: f.feature, isActive:f.isActive, integrationFeatureDynamicFields: (f.integrationFeatureDynamicFields??[]).map((i:any) => 
            { return { 
                  id: i.id,
                  type: i.type as IntegrationDynamicFieldType,
                  value: i.value??''
              }
            })
          } as IntegrationFeature 
        })
      } as Integration
    }


    

  }